import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiConfig from '../axiosConfig';


export const getAllProducts = createAsyncThunk(
	'recommendation/getAllSKU',
	async ({ countryCode }) => {
		if (countryCode == null) countryCode = 'my';

		const response = await apiConfig
			.get(`products/`, { params: { countryCode } })
			.then((response) => response)
			.catch((error) => error);

		return response.data;
	}
);

export const getProducts = createAsyncThunk(
	'recommendation/product/get',
	async ({ countryCode, active = true }) => {
		if (countryCode == null) countryCode = 'my';
		const response = await apiConfig
			.get(`recommendation-products/list/${countryCode}/${active ? '1' : '0'}`)
			.then((response) => response)
			.catch((error) => error);

		return response.data;
	}
);

export const addProduct = createAsyncThunk(
	'recommendation/product/add',
	async (payload, { rejectWithValue }) => {
		try {
			const response = await apiConfig.post(`recommendation-products/add`, payload);
			return response.data;
		} catch (error) {
			if (!error.response) {
				throw error;
			}
			return rejectWithValue(error.response.data);
		}
	}
);

export const deleteProduct = createAsyncThunk(
	'recommendation/product/delete',
	async ({ id }, { rejectWithValue }) => {
		try {
			const response = await apiConfig.delete(`recommendation-products/delete/${id}`);
			return response.data;
		} catch (error) {
			if (!error.response) {
				throw error;
			}
			return rejectWithValue(error.response.data);
		}
	}
);

export const updateOrder = createAsyncThunk(
	'recommendation/product/patch',
	async (payload, { rejectWithValue }) => {
		try {
			const response = await apiConfig.patch(`recommendation-products/patch`, payload);
			return response.data;
		} catch (error) {
			if (!error.response) {
				throw error;
			}
			return rejectWithValue(error.response.data);
		}
	}
);


const recommendationProductsManagementSlice = createSlice({
	name: 'recommendationProductsManagement',
	initialState: {
		status: null,
		products: [],
		allProductStatus: null,
    allProducts: [],
	},
	reducers: {},
	extraReducers: {
		[getAllProducts.pending]: (state) => {
			state.allProductStatus = 'loading';
		},
		[getAllProducts.fulfilled]: (state, action) => {
			const response = action.payload;
			const data = response && response.data ? response.data : [];
			state.allProducts = data;
			state.allProductStatus = 'OK';
		},
		[getAllProducts.rejected]: (state, action) => {
			state.allProductStatus = 'failed';
		},
		[getProducts.pending]: (state) => {
			state.status = 'loading';
		},
		[getProducts.fulfilled]: (state, action) => {
			const response = action.payload;
			const data = response && response.data ? response.data : [];
			state.products = data;
			state.status = 'OK';
		},
		[getProducts.rejected]: (state, action) => {
			state.status = 'failed';
		},
	},
});

export const assetManagementActions = recommendationProductsManagementSlice.actions;
export default recommendationProductsManagementSlice.reducer;
